import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest, Subscription } from 'rxjs';
import { NavLink } from '../shell/nav-menu';
import { SettingsMenuService } from './settings-menu.service';

/**
 * /settings (no page chosen yet) and /settings/<key>: the settings pages whose design is not
 * built yet. They show the mockup's page heading over an empty page; each gets its UI as it is
 * migrated. A key this user's list does not hold shows "not available".
 */
@Component({
    selector: 'app-settings-page',
    templateUrl: './settings-page.component.html',
    styleUrls: ['./settings-page.component.scss']
})
export class SettingsPageComponent implements OnInit, OnDestroy {
    key = '';
    link: NavLink = null;
    group = '';
    systemSettings: NavLink = null;
    private subscription: Subscription;

    constructor(private route: ActivatedRoute, private router: Router, private menu: SettingsMenuService) { }

    ngOnInit() {
        this.subscription = combineLatest(this.route.paramMap, this.menu.sections$).subscribe(([params, sections]) => {
            this.key = params.get('key') || '';
            // /settings opens the settings page last used, else System Settings (once the list is loaded).
            if (!this.key && sections.length) {
                const landing = SettingsMenuService.landing(sections);
                if (landing) {
                    this.router.navigateByUrl(landing, { replaceUrl: true });
                    return;
                }
            }
            const page = this.key ? SettingsMenuService.find(sections, '/settings/' + this.key) : null;
            this.link = page ? page.link : null;
            this.group = page ? page.group : '';
            this.systemSettings = null;
            sections.forEach(s => s.links.forEach(l => { if (l.id === 'system-settings') { this.systemSettings = l; } }));
        });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
